/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from "react";

interface Props {
  className?: string;
}

export const Component3: React.FC<Props> = ({ className }: Props) => {
  return (
    <svg id="Component3"
      className={`${className}`}
      fill="none"
      height="42"
      viewBox="0 0 41 42"
      width="41"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M32.7456 21.4364C32.7456 12.6346 25.5846 5.47363 16.7824 5.47363C16.6014 5.47363 16.4543 5.62036 16.4543 5.80179V37.0718C16.4543 37.2528 16.6014 37.4 16.7824 37.4C25.5846 37.3995 32.7456 30.2381 32.7456 21.4364Z"
        fill="white"
      />
    </svg>
  );
};
